module.exports = __webpack_public_path__ + "img/bell.28641041.svg";